<template lang="pug">
  div(class="empty-table" data-test="empty-table-block")
    div(class="empty-table__icon")
      v-img(
        :src="require(`~/assets/images/${imageName}.${imageExt}`)"
        max-width="32"
      )
    h2(class="title-24px medium mb-2") {{ $t(title) }}
    p(
      v-if="subtitle"
      class="text-14px light"
    ) {{ subtitle }}
    div(class="empty-table__actions pt-4")
      slot(name="actions")
</template>

<script>
export default {
  name: 'MBlockEmptyTable',
  props: {
    imageName: {
      type: String,
      default: 'file'
    },
    imageExt: {
      type: String,
      default: 'png'
    },
    title: {
      type: String,
      default: 'No items were found'
    },
    subtitle: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped lang="scss">
.empty-table {
  max-width: 500px;
  width: 100%;
  text-align: center;

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;

    margin: 0 auto 16px auto;

    width: 80px;
    height: 80px;

    border-radius: 24px;

    background: $background-secondary;
  }

  &__actions {
    display: flex;
    justify-content: center;
    gap: 16px;

    &::v-deep {
      .v-btn {
        min-width: 184px !important;
      }
    }
  }
}
</style>
